import { PortalAccountStateDto } from "@/api";
import { useTranslation } from "@/translations";

/**
 * The display label per access state — single source for the status cards and the client status
 * widget, so the same state can never carry two different names on one screen.
 */
export function usePortalAccountStateLabels(): Record<PortalAccountStateDto, string> {
  const { t } = useTranslation();

  return {
    [PortalAccountStateDto.NotGranted]: t("portalAccess.state.notGranted"),
    [PortalAccountStateDto.InvitationSent]: t("portalAccess.state.invitationSent"),
    [PortalAccountStateDto.Registered]: t("portalAccess.state.registered"),
    [PortalAccountStateDto.Locked]: t("portalAccess.state.locked"),
  };
}
